import { render, staticRenderFns } from "./newsConfig.vue?vue&type=template&id=5832b59c&scoped=true"
import script from "./newsConfig.vue?vue&type=script&lang=js"
export * from "./newsConfig.vue?vue&type=script&lang=js"
import style0 from "./newsConfig.vue?vue&type=style&index=0&id=5832b59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5832b59c",
  null
  
)

export default component.exports